import handlers from './handlers'
import { isValidationError, retrieveError } from './handlers/utils'

export interface IFailedRequest {
  action: any
  error: any
  request: any
  store: any
}

export const handle = (failedRequest: IFailedRequest) => {
  const { error } = failedRequest

  if (isValidationError(error)) {
    return handlers.validationError(failedRequest)
  }

  const errorMessage = retrieveError(error)

  const handler = handlers[errorMessage] ? handlers[errorMessage] : handlers[error.code]

  if (!handler) {
    return handlers.default(failedRequest)
  }

  return handler(failedRequest)
}
